import enMessages from './en';
import heMessages from './he';
import yiMessages from './yi';
import frMessages from './fr';

const messages = {
    he: heMessages,
    yi: yiMessages,
    en: enMessages,
    fr: frMessages,
};

export const i18nProvider = locale => messages[locale];